import { Tag } from '..';
import type { TTagProps } from '../types/TProps';

export const TagAccent = ({ className = '', ...props }: TTagProps) => (
  <Tag {...props} className={['tag--accent', className].filter(Boolean).join(' ')} />
);
